import type { ReactStoryblokComponent } from "types/storyblok";
import RichtextAdapter from "../RichtextAdapter";
import legalContentStyles from "./LegalContent.styles";
import type { ContentAdapterProps } from "../Content";

const LegalContentAdapter = ({ blok: { content }, sbEditable }: ReactStoryblokComponent<ContentAdapterProps>) => (
  <RichtextAdapter content={content} customStyles={legalContentStyles} sbEditable={sbEditable} />
);

export default LegalContentAdapter;
